export default __webpack_public_path__ + "static/media/correos-color.13b897bc.svg";